module.exports = __webpack_public_path__ + "80a53114fdeb83dba470de92a8866401.jpg";